import { createContext, useContext } from 'react';
import { BoundCanProps, createContextualCan } from '@casl/react';
import { AppAbility } from './ability';
import { subject as subjectFactory } from '@casl/ability';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';
import { createSubject } from './permissions';

export const AbilityContext = createContext<AppAbility>(undefined!);
export const CanInner = createContextualCan(AbilityContext.Consumer);

export const Can = (
  {
    appArea,
    a,
    ...props
  }: BoundCanProps<AppAbility> & { appArea: AppArea; a: any },
  context?: any,
) => {
  // app areas are added as their own permissions and do not need the app area prefix
  const resolvedSubject = Object.values(AppArea).includes(a)
    ? a
    : createSubject(appArea, a);

  return CanInner({ ...props, a: resolvedSubject }, context);
};

export function useCan() {
  const ability = useContext(AbilityContext);

  const innerCan = ability.can.bind(ability);

  return {
    can: <TEntity>({
      action,
      appArea,
      subject,
      data,
    }: {
      action: Actions;
      appArea: AppArea;
      subject: Subjects | AppArea;
      data?: TEntity;
    }): boolean => {
      const resolvedSubject = Object.values(AppArea).includes(
        subject as AppArea,
      )
        ? subject
        : createSubject(appArea, subject as Subjects);

      return innerCan(
        action,
        data ? subjectFactory(resolvedSubject, data) : resolvedSubject,
      );
    },
  };
}
